import React from "react";
import { connect } from "react-redux";
import PDPCatalogue from "components/PDPCatalogue";
import { loadProduct } from "modules/playground/action";
import { isLoggedIn } from "modules/session/selectors";

function SingleCataloguePage(props) {
  const catalogueId = props.location.pathname.split("/")[3];
  const [product, setProduct] = React.useState(undefined);

  React.useState(async () => {
    if (props.isLoggedIn) {
      const { data } = await props.loadProduct(parseInt(catalogueId, 10));
      setProduct(data);
    }
  }, []);

  console.log("anjing", product);

  return (
    <>
      {product && (
        <div>
          <PDPCatalogue
            points={product.price}
            prizeName={product.name}
            prizeImg={product.image}
          />
        </div>
      )}
    </>
  );
}

const withConnect = connect(
  state => ({
    isLoggedIn: isLoggedIn(state)
  }),
  { loadProduct }
);

export default withConnect(SingleCataloguePage);
